import ROLE from "@/common/ROLE";
const ListGroupRequestVue = () =>
	import("../views/modules/administrator/Request/ListGroupRequest.vue");
const ListTypeRequestVue = () =>
	import("../views/modules/administrator/Request/ListTypeRequest.vue");
const ListProcessStep = () =>
	import("../views/modules/administrator/ProcessStep/ListProcessStep.vue");
const RankManagementVue = () =>
	import(
		"../views/modules/administrator/DecentralizedManagement/RankManagement.vue"
	);
const RoleManagementVue = () =>
	import(
		"../views/modules/administrator/DecentralizedManagement/RoleManagement.vue"
	);
const ListProcess = () =>
	import("../views/modules/administrator/ProcessStep/ListProcess.vue");
const ListUserInfo = () =>
	import("@/views/modules/administrator/UserInfo/ListUserInfo.vue");

const ViewRequest = () =>
	import("@/views/modules/administrator/Request/ViewRequest.vue");

// const ListOrganization = () =>
// 	import(
// 		"@/views/modules/administrator/DecentralizedManagement/OrganizationsManagement"
// 	);
const QuanTriNhomloaiYeuCau = () =>
	import(
		"@/views/modules/administrator/QuanTriNhomLoaiYeuCau/QuanTriNhomLoaiYeucau"
	);
/**
 * @var {VueRouter} quantriRoutes
 */
const quantriRoutes = [
	{
		path: "nguoi-dung",
		name: "Quản trị người dùng",
		component: () =>
			import("@/views/modules/administrator/UserInfo/UserInfo"),
		meta: {
			template: true,
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
		children: [
			{
				path: "nguoi-dung",
				name: "Danh sách người dùng",
				component: ListUserInfo,
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
				children: [],
			},
			{
				path: "quyen",
				name: "Quản trị quyền",
				component: RoleManagementVue,
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
				children: [],
			},
		],
	},
	{
		path: "bieu-mau",
		component: () =>
			import("@/views/modules/administrator/TemplateForm/TemplateForm"),
		meta: {
			template: true,
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
		children: [
			{
				path: "",
				name: "Quản trị biểu mẫu",
				component: () =>
					import(
						"@/views/modules/administrator/TemplateForm/ListForm"
					),
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
				children: [],
			},
			{
				path: "tao-moi",
				name: "Tạo mới biểu mẫu",
				component: () =>
					import(
						"@/views/modules/administrator/TemplateForm/EditTemplateFormV2"
					),
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
				children: [],
			},
			{
				path: ":id",
				name: "Chỉnh sửa biểu mẫu",
				component: () =>
					import(
						"@/views/modules/administrator/TemplateForm/EditTemplateFormV2"
					),
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
				children: [],
			},
		],
	},
	// {
	// 	path: "list-process-step",
	// 	name: "Quản lý Bước thực hiện",
	// 	component: ListProcessStep,
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	{
		path: "danh-muc",
		component: () =>
			import("../views/modules/administrator/Category/Category.vue"),
		meta: {
			template: true,
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
		children: [
			{
				path: "",
				name: "Quản lý danh mục",
				component: () =>
					import(
						"../views/modules/administrator/Category/CategoryListV2.vue"
					),
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
			},
			{
				path: ":id",
				name: "Chỉnh sửa danh mục",
				component: () =>
					import(
						"../views/modules/administrator/Category/ViewRootCategory.vue"
					),
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
			},
		],
	},
	// DEPRECATED
	// {
	// 	path: "bieu-mau",
	// 	name: "Quản lý Biểu mẫu",
	// 	component: ListFormVue,
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	{
		path: "rank-management",
		name: "Quản lý Chức danh",
		component: RankManagementVue,
		meta: {
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
	},
	// {
	// 	path: "so-cong-van",
	// 	name: "Quản lý sổ công văn",
	// 	component: () =>
	// 		import("../views/modules/administrator/InCommingBook/ListBook"),
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	{
		path: "quy-trinh",
		component: () =>
			import("../views/modules/administrator/ProcessInfo/ProcessInfo"),
		meta: {
			template: true,
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
		children: [
			{
				path: "",
				name: "Quản lý Quy trình",
				component: ListProcess,
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
			},
			{
				path: "tao-moi",
				name: "Tạo mới quy trình",
				component: () =>
					import(
						"@/views/modules/administrator/ProcessInfo/EditProcessInfo"
					),
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
			},
			{
				path: ":id",
				name: "Chỉnh sửa quy trình",
				component: () =>
					import(
						"@/views/modules/administrator/ProcessInfo/EditProcessInfo"
					),
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
			},
		],
	},
	{
		path: "list-group-request",
		name: "Quản lý Nhóm yêu cầu",
		component: ListGroupRequestVue,
		meta: {
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
	},
	{
		path: "list-types-request",
		name: "Quản lý danh mục loại yêu cầu",
		component: ListTypeRequestVue,
		meta: {
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
	},
	{
		path: "list-process-step",
		name: "Quản lý Bước thực hiện",
		component: ListProcessStep,
		meta: {
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
	},
	// {
	// 	path: "list-organization",
	// 	name: "Quản lý Đơn vị",
	// 	component: ListOrganization,
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	// {
	// 	path: "list-data-field",
	// 	name: "ListDataField",
	// 	component: ListDataFieldVue,
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	// DEPRECATED
	// {
	// 	path: "list-form",
	// 	name: "Quản lý Biểu mẫu",
	// 	component: ListFormVue,
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	// DEPRECATED
	// {
	// 	path: "list-form/create-v2/:id",
	// 	name: "Chỉnh sửa loại yêu cầu",
	// 	component: CreateFormV2Vue,
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	// {
	// 	path: "list-form/create-v2",
	// 	name: "Thêm mới loại yêu cầu",
	// 	component: CreateFormV2Vue,
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	{
		path: "quan-tri-nhom-loai-yeu-cau",
		name: "Quản lý Loại yêu cầu",
		component: QuanTriNhomloaiYeuCau,
		meta: {
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
	},

	{
		path: "loai-yeu-cau",
		name: "Quản trị loại yêu cầu",
		component: () =>
			import("@/views/modules/administrator/Request/Request"),
		meta: {
			template: true,
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
		children: [
			{
				path: ":id",
				name: "Chỉnh sửa loại yêu cầu",
				component: () =>
					import("@/views/modules/administrator/Request/EditRequest"),
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
			},
			{
				path: "tao-moi",
				name: "Thêm mới loại yêu cầu 1",
				component: () =>
					import("@/views/modules/administrator/Request/EditRequest"),
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
			},
			{
				path: "view/:id",
				name: "Xem chi tiết loại yêu cầu",
				component: ViewRequest,
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
			},
		],
	},
	// WORKFLOW DISABLED
	// {
	// 	path: "manage-cargo",
	// 	name: "Quản trị hàng hóa dịch vụ",
	// 	component: () =>
	// 		import("../views/modules/administrator/ManageCargo/ListCargo.vue"),
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	// {
	// 	path: "bussiness-partner",
	// 	name: "Quản trị Business Partner",
	// 	component: () =>
	// 		import(
	// 			"../views/modules/administrator/BussinessPartner/ListBussinessPartner.vue"
	// 		),
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	// WORKFLOW DISABLED
	// {
	// 	path: "luu-tru",
	// 	name: "Quản trị lưu trữ",
	// 	component: () =>
	// 		import("@/views/modules/administrator/FileManager/FileManager"),
	// 	meta: {
	// 		requiresAuth: true,
	// 		roles: [ROLE.ROLE_ADMINISTRATOR],
	// 	},
	// },
	{
		path: "don-vi",
		component: () =>
			import("@/views/modules/administrator/Department/Department"),
		meta: {
			template: true,
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
		children: [
			{
				path: "",
				name: "Quản trị Đơn vị",
				component: () =>
					import(
						"@/views/modules/administrator/Department/ListDepartment"
					),
				meta: {
					requiresAuth: true,
					roles: [ROLE.ROLE_ADMINISTRATOR],
				},
				children: [],
			},
		],
	},
	{
		path: "trang-thai",
		name: "Quản lý danh mục trạng thái",
		component: () =>
			import("@/views/modules/administrator/Status/ListStatus"),
		meta: {
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
	},
	{
		path: "quan-ly-quy-phep",
		name: "Quản lý quỹ phép năm",
		component: () =>
			import("@/views/modules/quan-ly-quy-phep/LeaveFundList.vue"),
		meta: {
			requiresAuth: true,
			roles: [ROLE.ROLE_ADMINISTRATOR],
		},
	},
];
export default quantriRoutes;
